export * from './config'
export * from './validationErrorMessages'
import appConfig from './config'
export {appConfig}



// WEBPACK FOOTER //
// ./src/app/index.ts